<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório estatístico de pacientes">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-estatistico-paciente/List'

export default {
    components: {List},
}
</script>